import { useEffect, useState } from 'react';
import { Text } from '@chakra-ui/react';
import { CbAlertBanner } from 'ui/components';
export const MaintenanceBanner = () => {
  const [key, setKey] = useState(0);
  useEffect(() => {
    const handleShowBanner = () => {
      setKey(prev => prev + 1);
    };
    window.addEventListener('show-maintenance-banner', handleShowBanner);
    return () => window.removeEventListener('show-maintenance-banner', handleShowBanner);
  }, []);
  return <CbAlertBanner key={key} bannerId="maintenance-mode" color="var(--chakra-colors-kirby-500)" dismissable data-sentry-element="CbAlertBanner" data-sentry-component="MaintenanceBanner" data-sentry-source-file="MaintenanceBanner.tsx">
      <Text data-sentry-element="Text" data-sentry-source-file="MaintenanceBanner.tsx">
        Arcade is currently under maintenance and some functionality has been
        temporarily disabled. We will notify you when functionality has been
        restored.
      </Text>
    </CbAlertBanner>;
};